import React from 'react'
import { LeftOutline } from 'antd-mobile-icons'
import './newabout.css'
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NewAbout() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className=''>
            <div className='fixed_header'>
                <div className='backIcon' onClick={() => { navigate('/') }}>
                    <LeftOutline />
                </div>
                <p>{t('s3')}</p>
            </div>
            <div className='newAbout_box'>
                <img className='topimg' src="/assets/index/b1.jpg" alt="" />
                <div className="content">
                    <div className="title">
                        <img src="/assets/images/star.png" alt="" />
                        <span>{t('s3')}</span>
                        <img src="/assets/images/star.png" alt="" />
                    </div>
                    <div className="con">
                        <div className="name">{t('a1')}</div>
                        <div className="p p1"><span></span><p>{t('a2')}</p> </div>
                        <div className="p"><span></span><p>{t('a3')}</p> </div>
                        <div className="p"><span></span><p>{t('a4')}</p> </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
